var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen max-w-sm h-full"},[_c('div',{staticClass:"h-full flex flex-col shadow-xl overflow-y-auto bg-white p-4 lg:p-6"},[_c('div',{staticClass:"prose prose-sm",domProps:{"innerHTML":_vm._s(_vm.mdToHtml)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }